import { render, staticRenderFns } from "./EditTicketPositionComponent.vue?vue&type=template&id=546d7b8a&scoped=true"
import script from "./EditTicketPositionComponent.vue?vue&type=script&lang=ts"
export * from "./EditTicketPositionComponent.vue?vue&type=script&lang=ts"
import style0 from "./EditTicketPositionComponent.vue?vue&type=style&index=0&id=546d7b8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546d7b8a",
  null
  
)

export default component.exports